import React, { useState } from "react"
import {BigRedButton} from '../BigRedButton'
import { BurgerMenu } from "./burgerMenu"

export const Header=()=>{

    const [isBurgerActive,setIsBurgerActive]=useState(false)

    const burgerMenuHandler=()=>{
        setIsBurgerActive(!isBurgerActive)
    }

    return(
        <div className="header">
            <div className="__container">
                <div className="header_row">
                    <BigRedButton text='go back'/>
                    <a href="#" className="collapse header_link"><p>story</p></a>
                    <a href="#" className="collapse header_link"><p>story</p></a>
                    <div className="collapse header_red-dot"></div>
                    <img src={require("../../static/IMAGE_header_logo_ujjo.png")}/>
                    <div className="collapse header_purple-dot"></div>
                    <a href="#" className="collapse header_link"><p>story</p></a>
                    <a href="#" className="collapse header_link"><p>story</p></a>
                    <BigRedButton text='close'/>
                    <div onClick={burgerMenuHandler} className={`icon-menu ${isBurgerActive?'menu-open':''}`}><span></span></div>
                    
                </div>
            </div><BurgerMenu isBurgerActive={isBurgerActive}/>
        </div>
    )
}